import styled from 'styled-components';
import { InputNumber, Slider } from 'antd';

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	width: 100%;
`;

export const Label = styled.span`
	font-size: 14px;
	color: #262626;
`;

export const CustomSlider = styled(Slider)`
	flex: 1;

	.ant-slider-rail {
		background-color: #f0f0f0;
		height: 4px;
		border-radius: 3px;
	}

	.ant-slider-track {
		background-color: #2f54eb;
		height: 4px;
		border-radius: 3px;
	}

	.ant-slider-handle {
		width: 18px;
		height: 18px;
		margin-top: -7px;
		background-color: #2f54eb;
		border: none;
	}

	&.ant-slider-disabled {
		.ant-slider-handle,
		.ant-slider-track {
			background-color: #d9d9d9 !important;
		}
	}
`;

export const CustomLabel = styled.label`
	font-size: ${({ theme }) => theme.fonts.label.md.fontSize} !important;
	line-height: ${({ theme }) => theme.fonts.label.md.lineHeight} !important;
	font-weight: ${({ theme }) => theme.fonts.label.md.fontWeight} !important;
	letter-spacing: ${({ theme }) => theme.fonts.label.md.letterSpacing} !important;
	color: ${({ theme }) => theme.colors.text} !important;
	margin-bottom: 16px;
	display: block;
`;

export const CustomInputNumber = styled(InputNumber)`
	height: 40px;
	width: 100%;
	border-radius: 6px;

	.ant-input-number-input {
		text-align: center;
		font-size: 16px;
		padding: 0;
		height: 38px;
	}

	.ant-input-number-handler-wrap {
		display: flex !important;
		flex-direction: row !important;
		width: 60px;
		border-left: 1px solid #ddd;
		height: 100%;
		background: #fff;
	}

	.ant-input-number-handler {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		border: none !important;
		height: 100%;
		font-size: 18px;
		color: #999;
		cursor: pointer;

		&:hover {
			background: #f5f5f5;
			color: #2f54eb;
		}
	}

	.ant-input-number-handler-up-inner,
	.ant-input-number-handler-down-inner {
		display: none;
	}

	.ant-input-number-handler-up::after {
		content: '+';
		font-size: 18px;
		line-height: 1;
	}

	.ant-input-number-handler-down::after {
		content: '-';
		font-size: 18px;
		line-height: 1;
	}

	.ant-input-number-handler-down {
		border-right: 1px solid #ddd;
	}
`;
